import React from "react";
import useFetch from "@/lib/useFetch";
import { PageTitle } from "@/components/lux";
import { money } from "@/lib/api";
import { Check } from "lucide-react";
import { rankMeta } from "@/lib/ranks";

export default function Ranks() {
  const { data, loading } = useFetch("/user/ranks");
  if (loading || !data) return <><PageTitle title="Ranks" /><div className="skeleton h-40" /></>;
  return (
    <div className="space-y-6">
      <PageTitle title="Ranks & Rewards" subtitle={`Current rank: ${data.current_rank} · Matched $${money(data.matched)} · ${data.achieved_count}/${data.ranks.length} targets completed`} />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {data.ranks.map((r) => {
          const { color, Icon } = rankMeta(r.name);
          const achieved = r.achieved;
          const current = data.current_rank === r.name;
          return (
            <div key={r.name} className="relative overflow-hidden rounded-2xl p-5 transition-transform hover:-translate-y-1" data-testid={`rank-${r.name}`}
              style={{ background: `linear-gradient(135deg, ${color}, #10161f)`, border: current ? "2px solid rgba(255,255,255,0.9)" : `1px solid ${color}66`, boxShadow: "0 16px 36px -14px rgba(0,0,0,0.55)" }}>
              <div className="flex items-center justify-between">
                <div className="grid h-12 w-12 place-items-center rounded-full" style={{ border: "1px solid rgba(255,255,255,0.45)", background: "rgba(0,0,0,0.28)" }}>
                  <Icon size={24} className="text-white" />
                </div>
                {achieved && <span className="flex items-center gap-1 rounded-full bg-black/35 px-2 py-1 text-[11px] font-semibold text-emerald-300"><Check size={13} /> Achieved</span>}
              </div>
              <p className="mt-3 text-xl font-extrabold text-white">{r.name}{current && <span className="ml-2 rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-bold text-white">CURRENT</span>}</p>
              <div className="mt-3 grid grid-cols-3 gap-2 text-center">
                <div className="rounded-lg bg-black/25 p-2"><p className="text-[10px] text-white/70">Business</p><p className="text-sm font-bold text-white">${money(r.target, 0)}</p></div>
                <div className="rounded-lg bg-black/25 p-2"><p className="text-[10px] text-white/70">Reward</p><p className="text-sm font-bold text-white">${money(r.instant, 0)}</p></div>
                <div className="rounded-lg bg-black/25 p-2"><p className="text-[10px] text-white/70">Activity IB/day</p><p className="text-sm font-bold text-white">${money(r.salary)}</p></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
